
import { Mail, Clock, Info, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';

const ContactInfoSection = () => {
  return (
    <motion.div>
      <h2 className="text-2xl font-semibold mb-6 text-blue-700 flex items-center">
        <Info className="mr-2 h-6 w-6" />
        Yhteystiedot
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <motion.div 
          className="bg-white rounded-xl shadow-sm border border-blue-100 p-4"
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-blue-100 text-blue-500 flex items-center justify-center mr-3 flex-shrink-0">
              <Mail className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1 text-blue-600">Sähköposti</h3>
              <a href="mailto:asiakaspalvelu@lainasampo.fi" className="text-gray-700 hover:text-blue-500 transition-colors">
                asiakaspalvelu@lainasampo.fi
              </a>
            </div>
          </div>
        </motion.div>
        
        <motion.div 
          className="bg-white rounded-xl shadow-sm border border-blue-100 p-4"
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-blue-100 text-blue-500 flex items-center justify-center mr-3 flex-shrink-0">
              <Clock className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-1 text-blue-600">Palveluajat</h3>
              <p className="text-gray-700">Arkisin klo 9:00-16:00</p>
            </div>
          </div>
        </motion.div>
      </div>

      <Card className="border border-blue-100">
        <CardContent className="p-5">
          <div className="flex items-center mb-3">
            <Info className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" />
            <h3 className="text-lg font-semibold text-blue-700">Asiakaspalvelumme</h3>
          </div>
          <p className="text-gray-700 mb-3">
            Asiakaspalvelumme on avoinna arkisin klo 9-16. Vastaamme sähköposteihin yleensä saman päivän aikana.
          </p>
          <p className="text-gray-700">
            Voit myös tutustua <a href="/ukk" className="text-blue-600 hover:underline">usein kysyttyihin kysymyksiin</a>, 
            joista löydät vastauksia yleisimpiin kysymyksiin.
          </p>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ContactInfoSection;
